module.exports = __webpack_public_path__ + "static/media/notifications-small.80bb0d39.png";